import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_dispatch-command-17/artifacts/4l0ay7vy_Screenshot_20260712_215824_Gallery.jpg";
const DSS_LINK = "https://blackknightdss.life";
const OPS_EMAIL = "Bktoperations@blackknighttrans.com";

export default function SiteFooter() {
  return (
    <footer className="bk-footer" data-testid="site-footer">
      <div className="bk-footer-grid">
        <div className="bk-footer-brand">
          <img src={LOGO_URL} alt="Black Knight" className="bk-footer-logo" />
          <div className="bk-footer-tag">The Sword and Shield of Freight</div>
          <p className="bk-footer-blurb">
            Elite freight dispatch &amp; dispatch recruiting for independent owner-operators and motor carriers.
            We command the movement so you stay focused on the road.
          </p>
        </div>
        <div className="bk-footer-col">
          <h5>Company</h5>
          <Link to="/#solutions" data-testid="footer-solutions">Solutions</Link>
          <Link to="/#how">How It Works</Link>
          <Link to="/#dss-addon">DSS Engine</Link>
          <Link to="/#faq">FAQ</Link>
          <Link to="/#recruiting">Join Our Network</Link>
        </div>
        <div className="bk-footer-col">
          <h5>Legal</h5>
          <Link to="/privacy" data-testid="footer-privacy">Privacy Policy</Link>
          <Link to="/terms" data-testid="footer-terms">Terms of Service</Link>
          <Link to="/disclaimer" data-testid="footer-disclaimer">Service Disclaimer</Link>
        </div>
        <div className="bk-footer-col">
          <h5>Contact</h5>
          <a href={`mailto:${OPS_EMAIL}`}>{OPS_EMAIL}</a>
          <p>Mon – Fri · 5:00 AM – 4:00 PM</p>
          <p>Remote · US-Based · Nationwide</p>
          <a href={DSS_LINK} target="_blank" rel="noopener noreferrer">blackknightdss.life</a>
        </div>
      </div>
      <div className="bk-footer-bottom">
        <p>&copy; 2026 Black Knight Transportation LLC &middot; Established 2025. All Rights Reserved. | We are a Professional Freight Dispatch Service.</p>
      </div>
    </footer>
  );
}
